/**
 * FairwayBid – der Satz des Tages für Händler
 *
 * Die Kachel "Willkommen zurück" hatte auf der Händlerseite Platz für einen
 * Gedanken. Er wechselt alle zwei Tage: Täglich wäre eine Belohnung, für
 * die niemand zurückkommt, und wöchentlich hätte man ihn nach dem dritten
 * Blick überlesen.
 *
 * Warum keine Filmzitate
 * ----------------------
 * Filmdialoge sind geschützte Werke. Eine Handvoll davon fest ins Produkt
 * zu bauen und dauerhaft auszuspielen, ist keine beiläufige Zitierung mehr,
 * sondern systematische Übernahme – und ausgerechnet die bekanntesten
 * Geld-Zitate des Kinos ("Gier ist gut") feiern eine Haltung, die zu einem
 * Portal, das von Vertrauen zwischen Anlage und Anbieter lebt, ohnehin
 * schlecht passt.
 *
 * Die Sätze hier sind deshalb selbst geschrieben, in der Sprache des
 * Geschäfts, um das es geht: Angebote, Fristen, Termine, Verlässlichkeit.
 * Sie gehören FairwayBid, kosten keine Lizenz und lassen sich jederzeit
 * ergänzen.
 *
 * Reine Logik, kein React – damit prüfbar.
 */

/** Alle zwei Tage ein neuer Satz. */
export const TAGE_PRO_SPRUCH = 2;

export const SPRUECHE = [
  'Die meisten Aufträge gehen nicht verloren. Sie werden vergessen.',
  'Am Ende kauft niemand ein Produkt, sondern ein erledigtes Problem.',
  'Der günstigste Preis überzeugt einmal. Ein gehaltener Liefertermin überzeugt jedes Jahr wieder.',
  'Wer zuerst antwortet, verhandelt noch gegen niemanden.',
  'Ein Angebot, das keine Rückfragen auslöst, ist halb angenommen.',
  'Zwei Sätze Begründung kosten Sie fünf Minuten und ersparen dem Kunden eine Woche Zweifel.',
  'Kein Kunde merkt sich Ihren Katalog. Jeder merkt sich, ob Sie zurückgerufen haben.',
  'Vertrauen ist die einzige Marge, die niemand unterbieten kann.',
  'Wer im Herbst anbietet, liefert im Frühjahr. Wer im Frühjahr anbietet, entschuldigt sich.',
  'Drei Anlagen, eine Charge: Wer das rechnet, rechnet sich einen Vorteil aus.',
  'Ein klar geschriebenes Angebot ist der günstigste Vertrieb, den Sie haben.',
  'Nachfassen ist keine Aufdringlichkeit. Schweigen ist keine Höflichkeit.',
  'Der Zwei-Meter-Putt zählt so viel wie der Drive über 250. Im Angebot zählt der letzte Satz.',
  'Nicht jede Anfrage ist Ihr Auftrag. Die drei, die es sind, erkennen Sie am Vormittag.',
  'Wer den Bedarf der nächsten Saison kennt, muss heute nicht der Billigste sein.',
  'Eine Anlage vergleicht Angebote. Erinnern wird sie sich an Anbieter.',
];

/**
 * Welcher Satz gilt an diesem Tag?
 *
 * Gerechnet wird auf ganze Tage seit dem 1. Januar 1970, in UTC. Damit ist
 * das Ergebnis überall dasselbe – auf dem Server, im Browser und auf dem
 * Telefon eines Nutzers in einer anderen Zeitzone. Ein Zufallswert wäre
 * bequemer und würde bei jedem Renderlauf springen.
 *
 * @param {Date} datum
 * @returns {string}
 */
export const spruchFuer = (datum = new Date()) => {
  const zeit = datum instanceof Date ? datum.getTime() : NaN;
  if (!Number.isFinite(zeit)) return SPRUECHE[0];

  const tage = Math.floor(zeit / 86400000);
  const index = Math.floor(tage / TAGE_PRO_SPRUCH) % SPRUECHE.length;
  // Vor 1970 wäre der Rest negativ. Kommt nicht vor, kostet aber nichts.
  return SPRUECHE[(index + SPRUECHE.length) % SPRUECHE.length];
};
